import { Box, IconButton, Typography } from '@mui/material';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import IbssDrawer from '../../../../Components/Drawer/IbssDrawer';
import IbssInputDropDown from '../../../../Components/Inputs/SelectList/IbssInputDropDown';
import IbssButton from '../../../../Components/Buttons/Button/IbssButton';
import { appContext } from '../../../../AppContext';
import { IMultiSelectLabelOption, IQuestion, QuestionInputType } from './DataModels';
import OpenQuestionForm from './QuestionTypeForms/OpenQuestionForm';
import PolicyQuestionForm from './QuestionTypeForms/PolicyQuestionForm';
import HeaderForm from './QuestionTypeForms/HeaderForm';
import { IFile, IStepView } from './VisitorTypes';
import ImageForm from './QuestionTypeForms/ImageForm';
import TrueFalseQuestionForm from './QuestionTypeForms/TrueFalseQuestionForm';
import MultiOptionSelectForm from './QuestionTypeForms/MultiOptionSelectForm';
import Guid from '../../../../Common/Guid';
import IbssPageHeader from '../../../../Components/Headings/PageHeading/IbssPageHeader';

class AddQuestionDrawer extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            id: '',
            inputtype: QuestionInputType.TrueFalse,
            name: '',
            helpertext: '',
            value: '',
            goto: '',
            required: false,
            maxLength: '0',
            placeHolderText: '',
            inputHeight: '',
            policyText: '',
            requiredConfirmation: false,
            confirmationText: '',
            questionName: '',
            labels: [],
        };
    };

    public componentDidUpdate(prevProps: Readonly<IProps>): void
    {
        if (prevProps.open != this.props.open)
        {
            const { defaultValues } = this.props
            if (defaultValues)
            {
                this.setState({
                    id: defaultValues.Id,
                    inputtype: defaultValues.InputType,
                    name: defaultValues.Name,
                    helpertext: defaultValues.HelperText,
                    value: defaultValues.Value,
                    goto: defaultValues.goto,
                    required: defaultValues.Required,
                    maxLength: defaultValues.MaxLength,
                    placeHolderText: defaultValues.PlaceHolderText,
                    inputHeight: defaultValues.InputHeight,
                    policyText: defaultValues.PolicyText,
                    requiredConfirmation: defaultValues.RequiredConfirmation,
                    confirmationText: defaultValues.ConfirmationText,
                    questionName: defaultValues.QuestionName,
                    labels: defaultValues.Labels,
                });
            }
            if (defaultValues == null)
            {
                this.resetQuestionDetailsState(QuestionInputType.TrueFalse);
            }
        }
    }

    private getQuestionDetails(): IQuestion
    {
        return {
            Id: this.props.defaultValues ? this.state.id : Guid.new().toString(),
            InputType: this.state.inputtype,
            Name: this.state.name,
            HelperText: this.state.helpertext,
            Value: this.state.value,
            goto: this.state.goto,
            Required: this.state.required,
            MaxLength: this.state.maxLength,
            PlaceHolderText: this.state.placeHolderText,
            InputHeight: this.state.inputHeight,
            PolicyText: this.state.policyText,
            RequiredConfirmation: this.state.requiredConfirmation,
            ConfirmationText: this.state.confirmationText,
            QuestionName: this.state.questionName,
            Labels: this.state.labels,
            Answers: []
        }
    }

    private resetQuestionDetailsState(inputType: QuestionInputType): void
    {
        let labels = [] as IMultiSelectLabelOption[];

        if (inputType == QuestionInputType.TrueFalse)
        {
            labels = [{ Label: this.labels.funcOptionTrue_S, goto: 'next' }, { Label: this.labels.funcOptionFalse_S, goto: 'next' }]
        }
        if (inputType == QuestionInputType.MultiOptionSingleSelect)
        {
            labels = [{ Label: '', goto: 'next' }]
        }

        this.setState({
            id: '',
            inputtype: inputType,
            name: '',
            helpertext: '',
            value: '',
            goto: '',
            required: false,
            maxLength: '0',
            placeHolderText: '',
            inputHeight: '',
            policyText: '',
            requiredConfirmation: false,
            confirmationText: '',
            questionName: '',
            labels: labels,
        });
    }

    private onCancel(): void
    {
        this.props.onCancel();
        this.resetQuestionDetailsState(QuestionInputType.TrueFalse);
    }

    private onSaveQuestion(): void
    {
        this.props.onSaveQuestion(this.getQuestionDetails());
        this.resetQuestionDetailsState(QuestionInputType.TrueFalse);
    }

    private inputTypeChanged(value: QuestionInputType): void
    {
        this.setState({ inputtype: value });
        this.resetQuestionDetailsState(value)
    }

    private gotoValueChanged(index: number, goto: string): void
    {
        const options = this.state.labels;
        options[index].goto = goto;
        this.setState({ labels: options })
    }

    private optionLabelValueChanged(index: number, label: string): void
    {
        const options = this.state.labels;
        options[index].Label = label;
        this.setState({ labels: options })
    }

    private deleteOption(index: number): void
    {
        const options = this.state.labels;
        options.splice(index, 1)
        this.setState({ labels: options })
    }

    private questionFormIsValid(): boolean
    {
        let formIsValid = true;
        if (this.state.inputtype == QuestionInputType.TrueFalse)
        {
            formIsValid = this.state.questionName.length > 0;
        }
        else if (this.state.inputtype == QuestionInputType.Open)
        {
            formIsValid = this.state.questionName.length > 0;
        }
        else if (this.state.inputtype == QuestionInputType.Policy)
        {
            formIsValid = this.state.name.length > 0 && this.state.policyText.length > 0;
        }
        else if (this.state.inputtype == QuestionInputType.MultiOptionSingleSelect)
        {
            formIsValid = this.state.questionName.length > 0 && this.state.labels.some(x => x.Label.length == 0) == false;
        }
        else if (this.state.inputtype == QuestionInputType.Header)
        {
            formIsValid = this.state.value.length > 0;
        }
        else if (this.state.inputtype == QuestionInputType.SubHeader)
        {
            formIsValid = this.state.value.length > 0;
        }
        else if (this.state.inputtype == QuestionInputType.Image)
        {
            formIsValid = this.state.value.length > 0;
        }

        return formIsValid;

    }

    public render(): JSX.Element
    {
        const questionTypeOptions = [
            { label: this.labels.funcQuestionTypeTrueFalse_S, value: QuestionInputType.TrueFalse },
            { label: this.labels.funcQuestionTypeOpen_S, value: QuestionInputType.Open },
            { label: this.labels.funcQuestionTypePolicy_S, value: QuestionInputType.Policy },
            { label: this.labels.funcQuestionTypeMultiSelect_S, value: QuestionInputType.MultiOptionSingleSelect },
            { label: this.labels.funcQuestionTypeHeading_S, value: QuestionInputType.Header },
            { label: this.labels.funcQuestionTypeSubheading_S, value: QuestionInputType.SubHeader },
            { label: this.labels.funcQuestionTypeImage_S, value: QuestionInputType.Image },
        ];

        const steps = this.props.steps.map((x, index) => ({ label: `${this.labels.funcStep_S} ${index + 1}`, value: x.step }))

        return (
            <IbssDrawer
                anchor="right"
                open={this.props.open}
                onClose={() => this.props.close()}
                sx={{ width: '250px' }}
            >
                <div>
                    <Box px={5} pt={7} pb={3}>
                    <IbssPageHeader
                        title={this.labels.funcFieldSettings_S}
                        description={this.labels.funcFieldSettingsMessage_S}
                    />
                        <IbssInputDropDown value={this.state.inputtype} onChange={(e) => this.inputTypeChanged(e.target.value)} id='questionTypeOptions' options={questionTypeOptions} />
                    </Box>
                    <hr />
                    {
                        this.state.inputtype == QuestionInputType.Open &&
                        <OpenQuestionForm
                            onQuestionNameChange={(value) => this.setState({ questionName: value })}
                            questionName={this.state.questionName}
                            onPlaceholderTextChange={(value) => this.setState({ placeHolderText: value })}
                            placeholder={this.state.placeHolderText}
                            onHelperTextChange={(value) => this.setState({ helpertext: value })}
                            helperText={this.state.helpertext}
                            onMaxLengthChange={(value) => this.setState({ maxLength: value.toString() })}
                            maxLength={parseInt(this.state.maxLength)}
                            onRequiredChange={(value) => this.setState({ required: value })}
                            required={this.state.required}
                            onInputHeightChange={(value) => this.setState({ inputHeight: value })}
                            inputHeight={this.state.inputHeight}
                        />
                    }
                    {
                        this.state.inputtype == QuestionInputType.Policy &&
                        <PolicyQuestionForm
                            onPolicyNameChange={(value) => this.setState({ name: value })}
                            policyName={this.state.name}
                            onPolicyTextChange={(value) => this.setState({ policyText: value })}
                            policyText={this.state.policyText}
                            onRequiredConfirmationChange={(value) => this.setState({ requiredConfirmation: value })}
                            requiredConfirmation={this.state.requiredConfirmation}
                            onConfirmationTextChange={(value) => this.setState({ confirmationText: value })}
                            confirmationText={this.state.confirmationText}
                        />
                    }
                    {
                        (this.state.inputtype == QuestionInputType.Header || this.state.inputtype == QuestionInputType.SubHeader) &&
                        <HeaderForm
                            onValueChange={(value) => this.setState({ value: value })}
                            value={this.state.value}
                            type={this.state.inputtype}
                        />
                    }
                    {
                        this.state.inputtype == QuestionInputType.Image &&
                        <ImageForm
                            onValueChange={(value) => this.setState({ value: value })}
                            value={this.state.value}
                            images={this.props.images}
                            uploadFile={(filename, file, processAsMap) => this.props.uploadFile(filename, file, processAsMap)}
                        />
                    }
                    {
                        this.state.inputtype == QuestionInputType.TrueFalse &&
                        <TrueFalseQuestionForm
                            answerOptions={this.state.labels.map(x => ({ label: x.Label, goto: x.goto }))}
                            steps={steps}
                            onQuestionNameChange={(value) => this.setState({ questionName: value })}
                            questionName={this.state.questionName}
                            onHelperTextChange={(value) => this.setState({ helpertext: value })}
                            helperText={this.state.helpertext}
                            gotoValueChanged={(index: number, goto: string) => this.gotoValueChanged(index, goto)}
                            requiredFieldSelected={(value) => this.setState({ required: value })}
                            required={this.state.required}
                        />
                    }
                    {
                        this.state.inputtype == QuestionInputType.MultiOptionSingleSelect &&
                        <MultiOptionSelectForm
                            answerOptions={this.state.labels.map(x => ({ label: x.Label, goto: x.goto }))}
                            steps={steps}
                            onQuestionNameChange={(value) => this.setState({ questionName: value })}
                            questionName={this.state.questionName}
                            onHelperTextChange={(value) => this.setState({ helpertext: value })}
                            helperText={this.state.helpertext}
                            gotoValueChanged={(index: number, goto: string) => this.gotoValueChanged(index, goto)}
                            onOptionLabelChange={(index: number, label: string) => this.optionLabelValueChanged(index, label)}
                            onDeleteOption={(index: number) => this.deleteOption(index)}
                            onAddNewOption={() => this.setState({ labels: [...this.state.labels, { Label: '', goto: 'next' }] })}
                        />
                    }
                    <hr />
                    <Box textAlign={'center'}>
                        <IbssButton variant='contained' color='secondary' onClick={() => this.onCancel()} className='mr-3'>{this.labels.HubButtonCancel}</IbssButton>
                        <IbssButton variant='contained' color='primary' disabled={!this.questionFormIsValid()} onClick={() => this.onSaveQuestion()}>{this.props.defaultValues ? this.labels.funcUpdateField_S : this.labels.funcAddField_S}</IbssButton>
                    </Box>
                </div>

            </IbssDrawer>
        )
    }
}

export default AddQuestionDrawer;

export interface IProps
{
    open: boolean;
    close: () => void;
    onCancel: () => void;
    onSaveQuestion: (
        questionDetails: IQuestion
    ) => void;
    defaultValues: IQuestion | null;
    images: IFile[];
    uploadFile: (filename: string, file: FormData, processAsMap: boolean) => Promise<void>
    steps: IStepView[];
}

export interface IState
{
    id: string,
    inputtype: QuestionInputType,
    name: string,
    helpertext: string,
    value: string,
    goto: string,
    required: boolean,
    maxLength: string,
    placeHolderText: string,
    inputHeight: string,
    policyText: string,
    requiredConfirmation: boolean,
    confirmationText: string,
    questionName: string,
    labels: IMultiSelectLabelOption[],
}